export default "__VITE_ASSET__DnUwJdB$__"